import axios from "axios";
const jsonConfig = require("../../config.json");


const getalertbydescriptiontype = async (description) => {
    console.log("iddddd",description)
    let allResponse = {}
    try {
        const Response = await  axios.get(
            jsonConfig.apiUrl + "alertbydescriptionType/"+description, 
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        
        allResponse = Response;
        console.log("allResponse",allResponse)
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}


export default getalertbydescriptiontype;